(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    if (!window.fcspCartConfigurationBound) {
    window.fcspCartConfigurationBound = true;
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-remove-configuration]');
      if (!button) return;
      event.preventDefault();
      const configurationId = button.dataset.removeConfiguration;
      const selector = `[data-configuration-id="${CSS.escape(configurationId)}"]`;
      const keys = [...new Set([...document.querySelectorAll(selector)].map((row) => row.dataset.key).filter(Boolean))];
      const updates = Object.fromEntries(keys.map((key) => [key, 0]));
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error(await response.text());
        window.location.reload();
      } catch (requestError) {
        button.disabled = false;
        button.textContent = button.dataset.removeError;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
